import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  excerpt: string;
  coverImage: string;
  category: string;
  date: string;
  readTime: string;
}

export default function ArticleCard({ slug, title, excerpt, coverImage, category, date, readTime }: ArticleCardProps) {
  return (
    <Link
      to={`/article/${slug}`}
      className="group flex flex-col sm:flex-row gap-4 p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-lg overflow-hidden">
        <img
          src={coverImage}
          alt={title}
          title={title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 flex flex-col justify-between">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-md whitespace-nowrap">
              {category}
            </span>
          </div>
          <h3 className="text-base font-semibold text-foreground-900 mb-1 group-hover:text-primary-500 transition-colors duration-200 font-heading line-clamp-2">
            {title}
          </h3>
          <p className="text-sm text-foreground-500 line-clamp-2">{excerpt}</p>
        </div>
        <div className="flex items-center gap-3 text-xs text-foreground-400 mt-2">
          <span className="whitespace-nowrap"><i className="ri-calendar-line mr-1"></i>{date}</span>
          <span className="whitespace-nowrap"><i className="ri-time-line mr-1"></i>{readTime}</span>
        </div>
      </div>
    </Link>
  );
}